/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Select_Folder_TitleInputs */



/**
* | output |
* | --- |
* | "Embed Audio - Select Target Folder" |
*
* @param {Audio_Embed_Export_Select_Folder_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_select_folder_title = /** @type {((inputs?: Audio_Embed_Export_Select_Folder_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Select_Folder_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Intégrer l'audio - Sélectionner le dossier cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio einbetten – Zielordner auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Incorpora audio - Seleziona la cartella di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Встроить аудио — Выберите целевую папку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar audio - Seleccionar carpeta de destino")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("嵌入音频 - 选择目标文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声埋め込み - 対象フォルダを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो एम्बेड करें - लक्षित फ़ोल्डर चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Incorporar áudio - Selecione a pasta de destino")
	return /** @type {LocalizedString} */ ("Embed Audio - Select Target Folder")
});